<template>
  <div class="col-12 attributesBlock sizeDropBlock">
    <span class="attr-title"
          v-if="getAttributeGroupSortedAttributes.length > 1"
          v-html="t('product.page.available.in',
           {
             params: [{
               count: getAttributeGroupSortedAttributes.length,
               attributeGroupName:attributeGroup.attributeGroupName
             }]
           })">
    </span>

    <span v-else class="attr-title" v-html="`${attributeGroup.attributeGroupName}`"></span>

    <div class="native_slider-lg">
      <div v-for="attribute in getAttributeGroupSortedAttributes"
           :key="attribute.attributeId"
           v-on:click="setSelected(attribute.attributeId)"
           :class="getAttributeClass(attribute.attributeId)"
           class="native_slider-li">
        {{ attribute.attributeName }}
        <span v-if="attributeUnavailable(attribute.attributeId)">({{
            t('product_status.unavailable.out_of_stock')
          }})
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, flatten } from 'lodash-es'
import store from '../../../vue/store'

export default {
  name: 'AttributeTextSelector',
  props: ['attributeGroup', 'productData'],
  data() {
    return {
      version: '0.0.2',
      visible: false,
      selected: null
    }
  },
  computed: {
    getSelectedText() {
      if (!this.selected) {
        return ''
      }
      const selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    },
    getAttributeIdsWithStock() {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    },
    getAttributeGroupSortedAttributes() {
      //  sort based on getAttributeIdsWithStock in the end of the list
      const attributeGroup = cloneDeep(this.attributeGroup)
      return attributeGroup.attributes.sort((a, b) => {
        if (this.getAttributeIdsWithStock.includes(a.attributeId) && !this.getAttributeIdsWithStock.includes(b.attributeId)) {
          return -1
        }
        if (!this.getAttributeIdsWithStock.includes(a.attributeId) && this.getAttributeIdsWithStock.includes(b.attributeId)) {
          return 1
        }
        return 0
      })
    },
    cartContents() {
      return store.getters.cartContents
    }
  },
  mounted() {
    for (const attribute of this.attributeGroup.attributes) {
      if (!this.attributeUnavailable(attribute.attributeId)) {
        this.setSelected(attribute.attributeId)
        break
      }
    }
  },
  methods: {
    setSelected(attributeId) {
      this.selected = attributeId
      this.visible = false
      this.$emit('attribute-clicked', attributeId)
    },
    getAttributeClass(attributeId) {
      const productStockForAttributeId = this.productStockForAttributeId(attributeId)
      const productCodeId = productStockForAttributeId ? productStockForAttributeId.productCodeId : null
      const cartProductCode = this.cartContents.find(item => item.productCodeId === productCodeId)
      const cartContentQuantity = cartProductCode ? cartProductCode.quantity : 0
      if (!productStockForAttributeId || productStockForAttributeId.productStock - cartContentQuantity <= 0) {
        return 'disabled'
      }
      return this.selected === attributeId ? 'selected' : ''
    },
    productStockForAttributeId(attributeId) {
      return this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
    },
    attributeUnavailable(attributeId) {
      const productStockForAttributeId = this.productStockForAttributeId(attributeId)
      const productCodeId = productStockForAttributeId ? productStockForAttributeId.productCodeId : null
      const cartProductCode = this.cartContents.find(item => item.productCodeId === productCodeId)
      const cartContentQuantity = cartProductCode ? cartProductCode.quantity : 0
      return !productStockForAttributeId || productStockForAttributeId.productStock - cartContentQuantity <= 0
    }
  }
}
</script>

<style lang="scss" scoped>
.attributesBlock {
  position: relative;
}

// .toggleAttrsBlk{position:absolute; top:auto; z-index:10; background:#fff; border-radius:3px; max-width:300px; left:0; min-width:250px;
//   ul{display:block; width:100%; list-style: none; margin:0; padding:0; font-size:15px;
//     li{display: block; width:100%; padding-bottom:3px; padding-top:3px; color:#707070; border-bottom:1px solid #eaeaea; -webkit-transition: all 300ms ease-in-out; transition: all 300ms ease-in-out; padding-left:10px; padding-right:10px;
//       &:last-child{border-bottom:0}
//       &:hover{background:#eaeaea; color:var(--prime2)}
//       &.disabled{
//         opacity: 0.8;
//         color: red;
//       }
//       span.similar-not-available {
//         font-size: 13px
//       }
//     }
//   }
// }
.attributes-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    border-bottom: 1px solid white;
  }
}

.selectDropSize {
  display: block;
  padding-left: 5px;
  padding-right: 45px;
  position: relative;
  background: #fff;
  border: 1px solid #eaeaea;
  color: #707070;
  border-radius: 3px;
  padding-bottom: 10px;
  padding-top: 10px;
  line-height: 1;

  em {
    position: absolute;
    right: 10px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 12px
  }
}

.attributes-list {
  max-height: 185px;
  overflow: auto;
}

.native_slider-lg {
  grid-auto-columns: max-content;
  grid-gap: 15px;
}

.native_slider-li {
  color: #000000;
  padding: 10px;
  border: 1px solid #000000;
  border-radius: 8px;
  cursor: pointer;
}

.native_slider-li.selected {
  border: 1px solid #FFCC1C;
  background: #FFCC1C;
}
</style>
